import { render, staticRenderFns } from "./basemanufacturerList.vue?vue&type=template&id=6b4a0abc&scoped=true"
import script from "./basemanufacturerList.vue?vue&type=script&lang=js"
export * from "./basemanufacturerList.vue?vue&type=script&lang=js"
import style0 from "./basemanufacturerList.vue?vue&type=style&index=0&id=6b4a0abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a0abc",
  null
  
)

export default component.exports